import React from 'react';
import LoadingDots from './LoadingDots';
import { useTranslation } from 'react-i18next';

type Mode = 'overlay' | 'inline';

const DialerBodyGate: React.FC<{
  loading: boolean;
  children: React.ReactNode;
  mode?: Mode;
  minHeight?: number;
  label?: string;
}> = ({
  loading,
  children,
  mode = 'overlay',
  minHeight = 420,
  label = 'Loading next contact',
}) => {
  const { t } = useTranslation();

  const translatedLabel = t('agentLayout.loadingContact', label);


  if (!loading) {
    return <>{children}</>;
  }

  if (mode === 'inline') {
    return (
      <div
        className="flex flex-col items-center justify-center w-full text-center"
        style={{ minHeight }}
      >
        <LoadingDots label={translatedLabel} className="scale-125" />
      </div>
    );
  }

  return (
    <div className="relative w-full md:col-span-3 md:row-span-2">
      <div className="opacity-0 pointer-events-none select-none" aria-hidden>
        {children}
      </div>


      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="absolute inset-0 bg-background/80 backdrop-blur-sm" />
        <div className="relative rounded-2xl border border-border bg-card/90 py-4 shadow-lg max-w-sm w-full flex items-center justify-center text-center">
          <LoadingDots label={translatedLabel} className="scale-125" />
        </div>
      </div>
    </div>
  );
};

export default DialerBodyGate;
